import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  ReplyService,
  TimerService,
  AuthService
} from '../../services';
import { ActivatedRoute } from '@angular/router';
import { LoadingService } from '@schoolbelle/common/loading';
import { Survey } from '../../classes';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { surveyCloseAtValidator, surveyOpenAtValidator } from './functions';
import { ToastrService } from 'ngx-toastr';
import { isIframe } from '../../functions';
import { CrosswindowMessageService } from '@schoolbelle/common/crosswindow-message';

@Component({
  selector: 'app-reply',
  templateUrl: './reply.component.html',
  styleUrls: ['./reply.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReplyComponent implements OnInit {
  survey: Survey;
  replyFormGroup: FormGroup;
  open_at: FormControl;
  close_at: FormControl;
  subscriptions = new Subscription();

  constructor(
    public reply: ReplyService,
    private timer: TimerService,
    private route: ActivatedRoute,
    private loading: LoadingService,
    private toastr: ToastrService,
    private message: CrosswindowMessageService,
    private cdRef: ChangeDetectorRef
  ) {
    
    this.replyFormGroup = new FormGroup({
      questions: new FormGroup({}),
      serverTimeOffset: new FormControl(0)
    });
  }

  ngOnInit() {
    if (this.route.snapshot.data.reply) {
      const {surveyData, timeData } = this.route.snapshot.data.reply;
  
      this.survey = new Survey(surveyData.id, surveyData.type);
      this.addControls();
      this.loadInitialData(surveyData, timeData);
      this.cdRef.detectChanges();
    } else {
      throw new Error('survey is not found.');
    }


    this.subscriptions.add(
      this.reply.onChange.subscribe(() => {
        this.cdRef.detectChanges();
      })
    );
  }
  loadInitialData(surveyData, timeData) {
    this.survey.load(surveyData)
    this.subscriptions.add(this.reply.watch(this.survey).subscribe());
    this.watchReplyTimeWindow(timeData);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  addControls() {
    this.open_at = new FormControl(this.survey.open_at);
    this.close_at = new FormControl(this.survey.open_at);
    this.replyFormGroup.setControl('open_at', this.open_at);
    this.replyFormGroup.setControl('close_at', this.close_at);
  }
  watchReplyTimeWindow(serverTimeOffset: number = 0) {
    const open_at = this.survey.open_at;
    const close_at = this.survey.close_at;
    const servertimestamp = Date.now() + serverTimeOffset;

    this.open_at.setValidators([surveyOpenAtValidator(serverTimeOffset)]);
    this.close_at.setValidators([surveyCloseAtValidator(serverTimeOffset)]);
    if (this.open_at.invalid) {
      this.subscriptions.add(
        this.timer
          .setTimeout(open_at - servertimestamp)
          .subscribe(() => this.cdRef.detectChanges())
      );
    }
    if (this.close_at.valid) {
      this.subscriptions.add(
        this.timer
          .setTimeout(servertimestamp - close_at)
          .subscribe(() => this.cdRef.detectChanges())
      );
    }
  }

  trackByIdFn(index: number, value: any) {
    return value.id;
  }
  submit() {
    if (!this.reply.isChanged) return alert('Nothing has changed');
    if (this.replyFormGroup.invalid)
      return alert('A required question(s) is not answered');
    if (this.survey.open_at > Date.now()) return alert('Survey not open yet.');
    if (this.survey.close_at < Date.now())
      return alert('Survey already closed.');

    let promise = this.reply
      .save(this.survey)
      .then(() => {
        this.toastr.success('ì ì¶íìµëë¤!');
        if (isIframe()) {
          const state = this.route.snapshot.queryParams.state;
          this.message.send(
            window.parent,
            { message: 'submitted', state },
            '*'
          );
        }
      })
      .catch(e => {
        this.toastr.error('failed ....' + e.message);
      });
    this.loading.open({ busy: promise, message: ' ì ì¶ì¤ìëë¤...' });
  }
}
